import { render, staticRenderFns } from "./folletos.vue?vue&type=template&id=146ca362&"
import script from "./folletos.vue?vue&type=script&lang=js&"
export * from "./folletos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports